import styled             from "styled-components";

import { Typo,
         cssFlexColumn, 
         themeColors,    
         themeTypos,
         typoAsCSS      } from "src/providers/theme/shared";



type TextareaLookAndFeel = {
  padding: number[];
  paddingArea: string;
  gap: number;
  minHeight: number;
  background: string;
  width: number;
  height: number;
  borderRadius: number;
  border: string;
  borderColorBox: string;
  placeholderTypo: Typo;
  placeholderColor: string;
  disabledBg: string;
  enabledBg: string;
};

const textarea: TextareaLookAndFeel = {
  padding: [0, 14, 16],
  paddingArea: '14px 16px 0 16px',
  gap: 12,
  minHeight: 140,
  background: themeColors.OverlayBackground,
  width: 100,
  height: 100,
  borderRadius: 14,
  border: `1px solid ${themeColors.SecondaryGray2}`,
  borderColorBox: themeColors.Blue1,
  placeholderTypo: themeTypos.GRTSKREG_W400_S12_LH22,
  placeholderColor: themeColors.SecondaryGray12,
  disabledBg: themeColors.SecondaryGray1,
  enabledBg: themeColors.PrimaryWhite,
};

export type TextareaVariants = "textarea_main";

export const textarea_variants: Map<TextareaVariants, TextareaLookAndFeel> =
  new Map<TextareaVariants, TextareaLookAndFeel>([["textarea_main", textarea]]);

export const Field = styled.div<{
  lookAndFeel: TextareaLookAndFeel;
}>`
  ${cssFlexColumn}
  width: ${(args) => args.lookAndFeel.width}%;
  height: ${(args) => args.lookAndFeel.height}%;
  gap: ${(args) => args.lookAndFeel.gap}px;
`;

export const Label = styled.label<{
  lookAndFeel: TextareaLookAndFeel;
}>`
  padding: ${(args) => args.lookAndFeel.padding[0]} ${(args) => args.lookAndFeel.padding[2]}px;
`;

export const Box = styled.div<{
  disabled: boolean;
  lookAndFeel: TextareaLookAndFeel;
}>`
  border: ${(args) => args.lookAndFeel.border};
  border-radius: ${(args) => args.lookAndFeel.borderRadius}px;
  background: ${({ disabled, lookAndFeel }) => (disabled ? lookAndFeel.disabledBg : lookAndFeel.enabledBg)};
  transition: border-color 120ms ease, box-shadow 120ms ease, background 120ms ease;

  &:focus-within {
    border-color: ${(args) => args.lookAndFeel.borderColorBox};
  }
`;

export const Area = styled.textarea<{
  lookAndFeel: TextareaLookAndFeel;
}>`
  display: block;
  width: ${(args) => args.lookAndFeel.width}%;
  min-height: ${(args) => args.lookAndFeel.minHeight}px;
  resize: vertical;
  padding: ${(args) => args.lookAndFeel.paddingArea};
  border: 0;
  outline: none;
  background: transparent;
  font: inherit;
  line-height: 1.5;
  text-align: left;

  &::placeholder {
    color: ${(args) => args.lookAndFeel.placeholderColor};
    ${(args) => typoAsCSS(args.lookAndFeel.placeholderTypo)};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
